<template>
  <div role="alert" :class="['mensagem', 'u-margem-inferior-pequena', `mensagem_cor-${tipo || 'erro'}`]"
    v-if="texto != null">
    <i :class="['far', `${this.definirIcone(tipo) || 'fa-times-circle'}`, 'mensagem__icone']"></i>
    <div class="mensagem__conteudo">
      <p v-if="titulo" class="mensagem__titulo">{{ this.titulo }}</p>
      <p class="mensagem__texto" v-html="this.texto"></p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['texto', 'tipo', 'titulo'],
  methods: {
    ocultarAlerta() {
      this.texto = null;
    },
    definirIcone(tipo) {
      let icones = {
        "info": "fa-info-circle",
        "sucesso": "fa-check-circle",
        "erro": "fa-times-circle",
        "atencao": "fa-exclamation-circle",
        "perigo": "fa-lock"
      };
      return icones[tipo];
    }
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// Alerta.vue?3f4f8847